import styled from 'styled-components';
import { theme } from 'styled-tools';

import { FontWeights, minWidth, TextButton } from '@calm-web/design-system';

export const Wrapper = styled.div<{
	isVisible: boolean;
}>`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: white;
	padding: 20px;
	opacity: ${p => (p.isVisible ? '1' : '0')};
	pointer-events: ${p => (p.isVisible ? '' : 'none')};
	transition: opacity ${theme('animation.transition')};
	z-index: ${p => theme('modal.zIndex')(p) - 1};
	text-align: center;
`;

export const WelcomeWrapper = styled.div`
	max-width: 85%;
	margin: auto;
	margin-top: 0;
`;
export const Icon = styled.svg`
	margin-top: 30px;
	margin-bottom: 12px;
	max-width: 120px;
	height: 40px;
	width: auto;
	${minWidth('desktop')} {
		margin-left: 6px;
		margin-right: 6px;
	}
`;

export const MaybeLater = styled(TextButton)`
	font-weight: ${FontWeights.Regular} !important;

	${minWidth('desktop')} {
		display: none !important;
	}
`;

export const DescriptionWrapper = styled.div`
	${minWidth('desktop')} {
		max-width: 560px;
		margin: auto;
	}
`;

export const ContentDisplayWrapper = styled.div`
	${minWidth('desktop')} {
		display: none;
	}
`;

export const ImageContainer = styled.div`
	display: none;
	${minWidth('desktop')} {
		background: url('/_n/images/share-free-content/Phone-Device.png');
		background-size: cover;
		background-position: center top;
		width: 424px;
		padding-top: 130px;
		margin-bottom: -28px;
		margin-top: 30px;
		max-height: 700px;
		flex: 3;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
`;

export const QRCode = styled.img`
	width: 140px;
	height: auto;
	margin: auto;
`;

export const DesktopContent = styled.div`
	display: flex;
	flex-direction: column;
`;
export const FlexWrapper = styled.div`
	${minWidth('desktop')} {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 100%;
	}
`;

export const QRCodeWrapper = styled.div`
	display: none;
	${minWidth('desktop')} {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
	}
`;

export const QRCodePadding = styled.div`
	display: flex;
	padding: 16px;
	background: white;
	border-radius: 15px;
`;
